import React, { useEffect, useState } from 'react'
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';

const Homefeatures = () => {

    const [homefeature, setHomefeaturehome] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchhomefeature = async () => {
            try {
                const homefeatureData = await ApiService.Commanfetchrequest('home-feature');
                setHomefeaturehome(homefeatureData);
                // console.log('Fetched Features:', homefeatureData);
            } catch (error) {
                console.error('Error fetching home feature:', error);
            } finally {
                setLoading(false);
            }
        }
        fetchhomefeature();
    }, []);

    return (
        <>
            {loading ? (

                <section id="services" className="services section light-background">

                    <div className="container section-title">
                        <h2><Skeleton height={30} width={200} /></h2>
                        <p><Skeleton height={10} width={400} /></p>
                    </div>
                    <div className="container">

                        <div className="row g-5">
                            {Array.from({ length: 8 }).map((_, index) => (
                                <div className="col-lg-6" key={index}>
                                    <div className="service-item item-cyan position-relative">
                                        <Skeleton width={70} height={60} style={{ marginRight: '10px' }} />
                                        <div>
                                            <h3><Skeleton width={100} height={20} /></h3>
                                            <p><Skeleton width={400} height={70} /></p>
                                            <a href="#" className="read-more stretched-link"><Skeleton width={100} height={10} /><Skeleton width={10} height={2} style={{ marginLeft: '10px' }} /></a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            ) : (

                <section id="services" className="services section light-background">

                    <div className="container section-title">
                        <h2>Plateform Features</h2>
                        <p>Everything you need to create a high-performance culture</p>
                    </div>
                    <div className="container">

                        <div className="row g-5">
                            {homefeature?.map((value, index) => {
                                return (
                                    <>
                                        <div className="col-lg-6" key={index}>
                                            <div className="service-item item-cyan position-relative">
                                                <img src={`https://sigohrmlpadmin.loopring.in//front/images/features/${value?.feature_image}`} style={{ width: 77, height: 75, marginRight: 10 }} alt="img" />
                                                <div>
                                                    <h3>{value?.title}</h3>
                                                    <p dangerouslySetInnerHTML={{ __html: value?.description }}></p>
                                                    <Link to={`/${value?.feature_url}`}  className="read-more stretched-link">Read More <i className="bi bi-arrow-right" /></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}


                        </div>
                    </div>
                </section>
            )}
        </>
    )
}

export default Homefeatures
